import React from 'react';
import bem from 'utils/bem';

import './index.sass';

const { block, el } = bem('legend');

const Legend = () => {
    return <div className={ block() }>
        <div className={ el('item', 'disabled') }>
            <div className={ el('item-color') }></div>
            <div className={ el('item-text') }>Недоступно</div>
        </div>
        <div className={ el('item', 'free') }>
            <div className={ el('item-color') }></div>
            <div className={ el('item-text') }>Есть свободные специалисты</div>
        </div>
        <div className={ el('item', 'selected') }>
            <div className={ el('item-color') }></div>
            <div className={ el('item-text') }>Выбранная дата</div>
        </div>
    </div>
}

export default Legend;
